export default "__VITE_ASSET__D3xD$eNY__"